"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActions = exports.createAction = exports.getActionName = void 0;

var _types = require("../types");

var _transform = require("./transform");

var _url = require("../helpers/url");

var _fetch = _interopRequireWildcard(require("../helpers/fetch"));

var _util = require("../helpers/util");

var _pipeline = require("../defaults/pipeline");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SUPPORTED_FETCH_OPTS = ['url', 'method', 'headers', 'credentials', 'query', 'body', 'signal'];
var SUPPORTED_REDUCE_OPTS = ['invalidateState', 'assignResponse', 'isArray', 'isPure'];

var getActionName = function getActionName(actionId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      resourceName = _ref.resourceName,
      _ref$resourcePluralNa = _ref.resourcePluralName,
      resourcePluralName = _ref$resourcePluralNa === void 0 ? (0, _util.getPluralName)(resourceName) : _ref$resourcePluralNa,
      _ref$isArray = _ref.isArray,
      isArray = _ref$isArray === void 0 ? false : _ref$isArray,
      alias = _ref.alias;

  return !resourceName ? actionId : "".concat(alias || actionId).concat((0, _util.ucfirst)(isArray ? resourcePluralName : resourceName));
};

exports.getActionName = getActionName;

var createAction = function createAction(actionId, _ref2) {
  var resourceName = _ref2.resourceName,
      _ref2$resourcePluralN = _ref2.resourcePluralName,
      resourcePluralName = _ref2$resourcePluralN === void 0 ? (0, _util.getPluralName)(resourceName) : _ref2$resourcePluralN,
      scope = _ref2.scope,
      _ref2$stripTrailingSl = _ref2.stripTrailingSlashes,
      stripTrailingSlashes = _ref2$stripTrailingSl === void 0 ? true : _ref2$stripTrailingSl,
      actionOpts = _objectWithoutProperties(_ref2, ["resourceName", "resourcePluralName", "scope", "stripTrailingSlashes"]);

  var type = (0, _types.scopeType)((0, _types.getActionType)(actionId), scope); // Actual action function with two args
  // Context usage changes with resolved method:
  // - GET/DELETE will be used to resolve query params (eg. /users/:id)
  // - POST/PATCH will be used to resolve query params (eg. /users/:id) and as request body

  return function (context) {
    var contextOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function (dispatch, getState) {
      // Prepare reduce options
      var reduceOpts = _objectSpread({}, _util.pick.apply(void 0, [actionOpts].concat(SUPPORTED_REDUCE_OPTS)), _util.pick.apply(void 0, [contextOpts].concat(SUPPORTED_REDUCE_OPTS))); // Support pure actions


      if (actionOpts.isPure) {
        dispatch({
          type: type,
          status: 'resolved',
          options: reduceOpts,
          context: context
        });
        return Promise.resolve();
      } // First dispatch a pending action


      dispatch({
        type: type,
        status: 'pending',
        options: reduceOpts,
        context: context
      }); // Prepare fetch options

      var fetchOpts = _objectSpread({}, _util.pick.apply(void 0, [actionOpts].concat(SUPPORTED_FETCH_OPTS)), _util.pick.apply(void 0, [contextOpts].concat(SUPPORTED_FETCH_OPTS))); // Support dynamic fetch options


      var resolvedfetchOpts = Object.keys(fetchOpts).reduce(function (soFar, key) {
        soFar[key] = (0, _util.isFunction)(fetchOpts[key]) ? fetchOpts[key](getState, {
          context: context,
          contextOpts: contextOpts,
          actionId: actionId
        }) : fetchOpts[key];
        return soFar;
      }, {});

      var url = resolvedfetchOpts.url,
          eligibleFetchOptions = _objectWithoutProperties(resolvedfetchOpts, ["url"]); // Build fetch url and options


      var urlParams = (0, _url.parseUrlParams)(url);
      var finalFetchUrl = (0, _fetch.buildFetchUrl)(context, {
        url: url,
        urlParams: urlParams,
        isArray: reduceOpts.isArray,
        stripTrailingSlashes: stripTrailingSlashes
      });
      var finalFetchOpts = (0, _fetch.buildFetchOpts)(context, eligibleFetchOptions);
      return (0, _fetch.default)(finalFetchUrl, finalFetchOpts).then((0, _transform.applyTransformPipeline)((0, _transform.buildTransformPipeline)(_pipeline.defaultTransformResponsePipeline, actionOpts.transformResponse))).then(function (payload) {
        return dispatch(_objectSpread({
          type: type,
          status: 'resolved',
          context: context,
          options: reduceOpts,
          receivedAt: Date.now()
        }, payload));
      }) // eslint-disable-line
      .catch(function (initialErr) {
        // beforeError hook
        var err = actionOpts.beforeError ? actionOpts.beforeError.reduce(function (errSoFar, beforeErrorHook) {
          return beforeErrorHook(errSoFar);
        }, initialErr) : initialErr;

        if (!err) {
          return;
        } // Catch HttpErrors


        if (err instanceof _fetch.HttpError) {
          dispatch({
            type: type,
            status: 'rejected',
            code: err.status,
            body: err.body,
            context: context,
            options: reduceOpts,
            receivedAt: Date.now()
          }); // Catch regular Errors
        } else {
          dispatch({
            type: type,
            status: 'rejected',
            code: null,
            body: err.message,
            context: context,
            options: reduceOpts,
            receivedAt: Date.now()
          });
        }

        throw err;
      });
    };
  };
};

exports.createAction = createAction;

var createActions = function createActions() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var resourceName = _ref3.resourceName,
      _ref3$resourcePluralN = _ref3.resourcePluralName,
      resourcePluralName = _ref3$resourcePluralN === void 0 ? (0, _util.getPluralName)(resourceName) : _ref3$resourcePluralN,
      _ref3$scope = _ref3.scope,
      scope = _ref3$scope === void 0 ? (0, _types.getTypesScope)(resourceName) : _ref3$scope,
      globalOpts = _objectWithoutProperties(_ref3, ["resourceName", "resourcePluralName", "scope"]);

  var actionKeys = Object.keys(actions);
  return actionKeys.reduce(function (actionFuncs, actionId) {
    // Add support for relative url override
    var url = actions[actionId].url;

    if (globalOpts.url && url && (0, _util.isString)(url) && url.substr(0, 1) === '.') {
      actions[actionId] = _objectSpread({}, actions[actionId], {
        url: "".concat(globalOpts.url).concat(url.substr(1))
      });
    }

    var actionOpts = actions[actionId];
    var actionName = actionOpts.name ? actionOpts.name : getActionName(actionId, {
      resourceName: resourceName,
      resourcePluralName: resourcePluralName,
      isArray: actionOpts.isArray,
      alias: actionOpts.alias
    });
    actionFuncs[actionName] = createAction(actionId, _objectSpread({
      resourceName: resourceName,
      resourcePluralName: resourcePluralName,
      scope: scope
    }, globalOpts, actionOpts));
    return actionFuncs;
  }, {});
};

exports.createActions = createActions;